import Money from 'common/Money';

/**
 * Sum amounts per currency, in first-seen order. Cross-currency cents can't
 * be added (Money.plus throws by design), so multi-currency selections get
 * one total per currency — e.g. a conversion selection reads "-$139.00" and
 * "+¥20,000" side by side.
 */
export const totalsByCurrency = (
  amounts: Array<{amount: number; currency: string}>,
): Money[] => {
  const byCurrency = new Map<string, number>();
  for (const {amount, currency} of amounts) {
    byCurrency.set(currency, (byCurrency.get(currency) ?? 0) + amount);
  }
  return [...byCurrency.entries()].map(([currency, total]) =>
    Money.fromInt(total, currency),
  );
};
